const theme = {
    isBuiltIn: true,
    id: "vignette",
    name: "Vignette",
    palette_name: "pastels",
    styleBackground: "vignette",
    defaultBackgroundColor: "background_light",
    styleTitleFont: "montserrat",
    styleBodyFont: "sourcesanspro",
    styleFontWeight: "heavy",
    styleDecoration: "block",
    styleElementStyle: "filled",
    styleShape: "circle",
    styleWeight: "medium",
    styleEffect: "shadow",
    fontBody: "sourcesanspro-body",
    fontBodyEmphasized: "SourceSansPro-SemiBold",
    fontBodyEmphasizedItalic: "SourceSansPro-SemiBoldItalic",
    fontBodyItalic: "SourceSansPro-Italic",
    fontBodyLetterSpacing: 0,
    fontBodyLineHeight: 1.9,
    fontBodyRegular: "SourceSansPro-Regular",
    fontBodyScaling: 100,
    fontBodyStrokeThickness: 2,
    fontBodyTextTransform: "auto",
    fontHeader: "montserrat-header-heavy",
    fontHeaderEmphasized: "Montserrat-Bold",
    fontHeaderEmphasizedItalic: "Montserrat-BoldItalic",
    fontHeaderItalic: "Montserrat-BoldItalic",
    fontHeaderLetterSpacing: 0.05,
    fontHeaderLineHeight: 1.4,
    fontHeaderRegular: "Montserrat-Bold",
    fontHeaderScaling: 100,
    fontHeaderStrokeThickness: 5,
    fontHeaderTextTransform: "uppercase",
    fontScale: 1,
    fontTitle: "montserrat-title-heavy",
    fontTitleEmphasized: "Montserrat-Bold",
    fontTitleEmphasizedItalic: "Montserrat-BoldItalic",
    fontTitleItalic: "Montserrat-BoldItalic",
    fontTitleLetterSpacing: 0.05,
    fontTitleLineHeight: 1.4,
    fontTitleRegular: "Montserrat-Bold",
    fontTitleScaling: 91,
    fontTitleTextTransform: "uppercase",
};

module.exports = theme;
